import React, { useEffect, useState } from "react";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import { useNavigate } from "react-router-dom";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { toast } from "react-hot-toast";
import { getVendorName } from "../../../utils/getVendorName";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import { downloadSampleCSV } from "../../../utils/downloadSampleCsv";
import { CircleLoaderComponent } from "../../../components/Loader/CircleLoaderComponent";
import CustomExport from "../../../components/CustomExport/CustomExport";
import { useFetchOrdersByIdMutation, useFetchOrdersByTypeMutation, useInsertOrdersMutation, useFetchOrdersMutation, useOrderListCsvMutation } from "../../../features/tenant/Orders/ordersApi";
import { hasPermission } from "../../../utils/hasPermission";
import ImageModal from "../../../components/Tenant/ImageModal/ImageModal";
import TenantSlugs from "../../../utils/TenantSlug";
import { FaImage } from "react-icons/fa";

const OrderList = () => {
  const navigate = useNavigate();
  const [myList, setMyList] = useState([])
  const [file, setFile] = useState();
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [csvData, setCsvData] = useState(null)
  const [latitude, setLatitude] = useState("1");
  const [longitude, setLongitude] = useState("1");
  const [errorRows, setErrorRows] = useState([])
  const [errorUploadModal, setErrorUploadModal] = useState(false)
  const [orderLines, setOrderLines] = useState([])
  const [orderLinesModal, setOrderLinesModal] = useState(false)
  const [showImageModal, setShowImageModal] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const vendorData = sessionStorage.getItem("vendorData");
  const tenantId = vendorData ? JSON.parse(vendorData)?.tenant_id : null;
  const isCentury = tenantId == TenantSlugs?.century;

  const getInvoiceImages = (invoiceImage) => {
    if (!invoiceImage) return [];
    if (Array.isArray(invoiceImage)) return invoiceImage;
    if (typeof invoiceImage === "string") {
      const trimmed = invoiceImage.trim();
      if (trimmed.startsWith("[") && trimmed.endsWith("]")) {
        try {
          return JSON.parse(trimmed);
        } catch (e) {
          console.error("Failed to parse invoice_image JSON:", e);
        }
      }
      return trimmed.split(",").map(url => url.trim()).filter(Boolean);
    }
    return [];
  };

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (error) => {
          console.log(error.message);
        }
      );
    } else {
      console.log('Geolocation is not supported by this browser.');
    }
  }, []);

  const [
    fetchOrders,
    {
      data: ordersData,
      isLoading: ordersIsLoading,
      isError: ordersIsError,
      error: ordersError,
    },
  ] = useFetchOrdersMutation();

  const [
    orderList,
    {
      data: orderListData,
      isLoading: orderListIsLoading,
      isError: orderListIsError,
      error: orderListError,
    },
  ] = useOrderListCsvMutation();

  const [
    fetchOrdersCsv,
    {
      data: orderCsvData,
      isLoading: orderCsvLoading,
      isError: orderCsvIsError,
      error: orderCsvError,
    },
  ] = useFetchOrdersMutation();

  const handleOnChange = (e) => {
    setFile(e.target.files[0]);
  };

  function parseCSV(string) {
    const csvHeader = string
      .slice(0, string.indexOf("\n"))
      .replace(/\s/g, "")
      .split(",");

    const csvRows = string.slice(string.indexOf("\n") + 1).split(/\r?\n/);
    const array = csvRows
      .map((row) => {
        const values = [];
        let insideQuotes = false;
        let currentField = "";

        for (let char of row) {
          if (char === "," && !insideQuotes) {
            values.push(currentField.trim());
            currentField = "";
          } else if (char === '"') {
            insideQuotes = !insideQuotes;
          } else {
            currentField += char;
          }
        }

        values.push(currentField.trim());
        return values;
      })
      .filter((values) => values.length === csvHeader.length)
      .map((values) => {
        const obj = csvHeader.reduce((object, header, index) => {
          object[header] = values[index].trim();
          return object;
        }, {});
        return obj;
      });

    // console.log("array", array);
    return array;
  }

  useEffect(() => {
    const hasViewPermission = hasPermission("orderList");

    if (!hasViewPermission) {
      navigate(`/genefied/${getVendorName()}/`);
    }

    fetchOrdersFunction();
  }, [limit, offset]);

  const fetchOrdersFunction = () => {
    fetchOrders({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      type: "transfer_point",
      body: {
        limit: limit,
        offset: offset,
      }
    });
  };

  const [
    bulkInsertOrders,
    {
      data: addOrdersData,
      isLoading: addOrdersLoading,
      error: addOrdersError,
    },
  ] = useInsertOrdersMutation();

  const [
    fetchOrderById,
    {
      data: orderDetailsData,
      isLoading: orderDetailsLoading,
      error: orderDetailsError,
    },
  ] = useFetchOrdersByIdMutation();

  useEffect(() => {
    if (orderDetailsError) {
      toast.error(orderDetailsError?.data?.message)
    }
    if (orderDetailsData?.body?.orderLine.length > 0) {
      setOrderLines(orderDetailsData?.body?.orderLine)
      setOrderLinesModal(true)
    }
  }, [orderDetailsData, orderDetailsError])


  if (ordersIsLoading) {
    toast.dismiss();
  }

  useEffect(() => {
    if (ordersData && ordersData.body) {
      toast.dismiss();
      setMyList(ordersData.body.order_list ? ordersData.body.order_list : []);


    }
  }, [ordersData])

  useEffect(() => {
    if (orderListData && orderListData.body) {
      toast.dismiss();
      setCsvData(orderListData.body.data)
    }
    if (orderListError) {
      toast.error("Something Went Wrong")
    }
  }, [orderListData, orderListError])

  useEffect(() => {
    if (addOrdersError) {
      toast.error(addOrdersError?.data?.message)
    }
    if (addOrdersData) {
      console.log(addOrdersData)
      if (addOrdersData.body.errorRows.length > 0) {
        toast.success("Orders Partially Added");
        setErrorRows(addOrdersData.body.errorRows)
        setErrorUploadModal(true)
      } else {
        toast.success("Orders Added");
      }
      fetchOrdersFunction()
    }
  }, [addOrdersData, addOrdersError])


  useEffect(() => {
    if (orderCsvData && orderCsvData?.body?.orders) {
      let csvList = orderCsvData.body.order_list.map(el => {
        const { voucher_date, created_at, ...rest } = el
        const date = new Date(voucher_date);
        if (isNaN(date)) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return { ...rest, voucher_date: `${year}-${month}-${day}` };
      })
      setCsvData(csvList);
    }

    if (orderCsvError) {
      setCsvData(null);
    }
  }, [orderCsvData, orderCsvError])

  const [showModal2, setShowModal2] = useState(false);

  const handleShowOrderLines = (data) => {
    fetchOrderById({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      id: data.id,
    })
  };

  const handleBulkUploadOrders = (data) => {
    if (
      window.confirm(`Confirm adding orders?`)
    ) {
      console.log(data)
      bulkInsertOrders({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        body: data,
      });
      setShowModal2(false);
    }
    return;
  };

  const handleOnSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }

    if (!file) {
      toast.error("Please select a file");
      return;
    }

    const fileReader = new FileReader();
    if (file) {
      fileReader.onload = function (event) {
        const text = event.target.result;
        let datas = parseCSV(text);
        console.log("datas>>>>>", datas)
        let payload = {
          "platform": "WEB",
          "lat": latitude,
          "log": longitude,
          "rows": JSON.parse(JSON.stringify(datas))
        }
        console.log(payload)
        handleBulkUploadOrders(payload);
      };
      fileReader.readAsText(file);
    }
  };
  const columns = [
    {
      name: "SNo",
      cell: (row, idx) => offset + Number(idx + 1),
      sortable: true,
      width: "90px",
      textAlign: "left",
    },
    {
      name: "Order No",
      cell: (row) => row.order_no,
      sortable: true,
      width: "300px",
    },
    {
      name: "Order Date",
      cell: (row) => {
        const date = new Date(row?.voucher_date);
        if (isNaN(date)) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      },
      sortable: true,
      width: "120px",
    },
    ...(isCentury
      ? [
          {
            name: "Invoice Image",
            cell: (row) => {
              const images = getInvoiceImages(row?.invoice_image);
              if (images.length === 0) return <span>-</span>;
              return (
                <div className="flex gap-2 items-center py-1">
                  {images.map((img, idx) => {
                    if (!img) return null;
                    return (
                      <button
                        key={idx}
                        type="button"
                        className="flex items-center justify-center p-1.5 rounded-lg border border-gray-300 bg-gray-50 text-gray-700 hover:bg-gray-100 hover:text-blue-600 transition-all shadow-sm"
                        title={`View Invoice Image ${idx + 1}`}
                        onClick={() => {
                          setPreviewImage(img);
                          setShowImageModal(true);
                        }}
                      >
                        <FaImage className="w-5 h-5 text-blue-600 hover:text-blue-800" />
                        {images.length > 1 && (
                          <span className="ml-1 text-xs font-semibold text-gray-500">
                            #{idx + 1}
                          </span>
                        )}
                      </button>
                    );
                  })}
                </div>
              );
            },
            width: "150px",
          },
        ]
      : []),
    {
      name: "Buyer Code",
      cell: (row) => row?.buyer_code,
      sortable: true,
      width: "100px",
    },
    {
      name: "Buyer name",
      cell: (row) => row?.buyer_name,
      sortable: true,
      width: "100px",
    },
    {
      name: "Seller Code",
      cell: (row) => row?.seller_code,
      sortable: true,
      width: "100px",
    },
    {
      name: "Seller Name",
      cell: (row) => row?.seller_name,
      sortable: true,
      width: "100px",
    },
    {
      name: "Quantity",
      cell: (row) => row.qty,
      sortable: true,
      width: "100px",

    },
    {
      name: "amount",
      cell: (row) => row.purchase_amount,
      sortable: true,
      width: "100px",

    },
    {
      name: "points",
      cell: (row) => row.points,
      sortable: true,
      width: "100px",
    },
    {
      name: "Transfer Points",
      cell: (row) => row.transfer_points,
      sortable: true,
      width: "100px",
    },
    {
      name: "Status",
      cell: (row) => {
        if (row.status === '0') {
          return "Pending"
        } else if (row.status === '1') {
          return "Approved"
        } else if (row.status === '2') {
          return "Rejected"
        }
      },
      sortable: true,
      width: "100px",

    },
    {
      name: "Remark",
      cell: (row) => row.remark,
      sortable: true,
      width: "100px",

    },
    {
      name: "",
      cell: (row) => (
        <button
          className="flex justify-center items-center rounded bg-primary px-3 pb-1.5 break-normal pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] "
          onClick={() => handleShowOrderLines(row)}
        >
          View
        </button>
      ),
      sortable: true,
      minWidth: "100px",
    }
  ];

  const errorColumn = [
    {
      name: "Customer Code",
      cell: (row) => row.customerCode,
      sortable: true,
      width: "100px",
    },
    {
      name: "Customer Name",
      cell: (row) => row?.customerName,
      sortable: true,
      width: "100px",
    },
    {
      name: "Bill Type",
      cell: (row) => row.billType,
      sortable: true,
      width: "100px",

    },
    {
      name: "Invoice Number",
      cell: (row) => row.invoiceNumber,
      sortable: true,
      width: "100px",

    },
    {
      name: "Invoice Date",
      cell: (row) => row.invoiceDate,
      sortable: true,
      width: "100px",
    },
    {
      name: "SKU Code",
      cell: (row) => row.skuCode,
      sortable: true,
      width: "100px",
    },
    {
      name: "Quantity",
      cell: (row) => row.quantity,
      sortable: true,
      width: "100px",
    }
  ];

  const orderDetailColumn = [
    {
      name: "Order No",
      cell: (row) => row.order_no,
      sortable: true,
      width: "300px",
    },
    {
      name: "Voucher No",
      cell: (row) => row?.voucher_no,
      sortable: true,
      width: "100px",
    },
    {
      name: "Voucher Date",
      cell: (row) => {
        const date = new Date(row?.voucher_date);
        if (isNaN(date)) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      },
      sortable: true,
      width: "100px",

    },
    {
      name: "Product Code",
      cell: (row) => row.product_code,
      sortable: true,
      width: "100px",

    },
    {
      name: "Quantity",
      cell: (row) => row.qty,
      sortable: true,
      width: "100px",
    },
    {
      name: "Purchase Amount",
      cell: (row) => row.purchase_amount,
      sortable: true,
      width: "100px",
    }, {
      name: "Points",
      cell: (row) => row.points,
      sortable: true,
      width: "100px",
    }, {
      name: "Transfer Points",
      cell: (row) => row.transfer_points,
      sortable: true,
      width: "100px",
    }
  ];


  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setLimit(newPerPage);
  };

  const fetchOrdersForCsvFunction = () => {
    orderList({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
    });
  };

  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center ">
        <div className="w-full">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Order List
            <LinksComponent />
          </div>
          <div className="p-3">
            <div className="flex gap-2 mb-3">

              <div>
                <CustomExport fetchData={fetchOrdersForCsvFunction} data={csvData} defaultColumnExport={[
                  "invoice_number",
                  "reference_number",
                  "date",
                  "buyer_name",
                  "seller_name",
                  "quantity",
                  "points",
                  "transfer_points"
                ]}
                  filename="orders_list"
                />
              </div>
            </div>
            <div className="w-full bg-white shadow rounded-lg">
              {(ordersIsLoading || orderCsvLoading || addOrdersLoading || orderDetailsLoading) && <CircleLoaderComponent />}
              <DataTableComponent
                columns={columns}
                data={myList}
                loading={ordersIsLoading}
                totalRows={ordersData?.body?.total_orders}
                handlePerRowsChange={handlePerRowsChange}
                handlePageChange={handlePageChange}
              ></DataTableComponent>
            </div>
          </div>
        </div>

        {orderLinesModal && (
          <ModalComponent show={orderLinesModal} setShow={(action) => {
            console.log("mMO", action)
            if (!action) {
              setOrderLines([])
              setOrderLinesModal(false)
            }
          }} size="3xl">
            <div className="w-full p-4">
              <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                Order Details
              </div>
              <DataTableComponent
                columns={orderDetailColumn}
                data={orderLines}
                pagination={false}
              ></DataTableComponent>
            </div>
          </ModalComponent>
        )}

        {showImageModal && (
          <ImageModal
            show={showImageModal}
            setShow={setShowImageModal}
            size="3xl"
            data={previewImage}
          >
            <div className="flex justify-center items-center p-2 bg-gray-100 rounded-lg">
              <img
                src={previewImage}
                alt="Preview"
                className="max-h-[75vh] max-w-full object-contain rounded"
              />
            </div>
          </ImageModal>
        )}

      </div>
    </>
  );
};

export default OrderList;
